'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { withTitan } from '../../hocs/withTitan/withTitan.js';

const VisuallyHidden = /*#__PURE__*/withTitan((_a, ref) => {
  var {
      as: Comp = 'span'
    } = _a,
    props = __rest(_a, ["as"]);
  return jsx(Comp, Object.assign({
    ref: ref,
    style: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: '1px',
      margin: '-1px',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      width: '1px',
      // https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
      whiteSpace: 'nowrap',
      wordWrap: 'normal'
    }
  }, props));
}, {
  name: 'VisuallyHidden'
});

export { VisuallyHidden };
//# sourceMappingURL=VisuallyHidden.js.map
